// shared-types/src/account/types.ts - Account entity types
import { AccountDomain } from "../accountDomain";

export interface Account {
  id: string;
  name: string;
  slug: string;
  address?: string;
  logoId?: string;
  currency: string;
  priceFormatPattern: string;
  instagram?: string;
  facebook?: string;
  whatsapp?: string;
  phone?: string;
  email: string;
  timezone: string;
  hasDelivery: boolean;
  status: AccountStatus;
  themeConfig?: ThemeConfig;
  privateKey?: string;
  demo: boolean;
  createdAt: Date;
  updatedAt: Date;
  deletedAt?: Date;

  priceFormat?: Intl.NumberFormatOptions;

  accountDomains?: AccountDomain[];
}

export enum AccountStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  PENDING = 'PENDING',
  SUSPENDED = 'SUSPENDED',
}

export interface ThemeConfig {
  backgroundColor: string;
  textColor: string;
  primaryColor: string;
  secondaryColor: string;
}
 